import logo from "./../pics/logn.jpg";
import { isMobile } from "react-device-detect";
import { i18n } from "../i18n";
import { useUserSettings } from "../user";
import Phone from "@mui/icons-material/Phone";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import "./../Footer.css";

export const Footer = () => {
  const [settings] = useUserSettings();
  const { language } = settings;

  const MobileView = () => {
    return (
      <div className="footer_m">
        <div className="m">
          <img src={logo} className="footer_img" alt="logo" />
        </div>
        <div className="m">
          <p className="title">{i18n({ index: "contact", language })}</p>

          <a
            className="row_row"
            href="https://wa.me/59892291919"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Phone
              style={{
                color: "#fff",
                fontSize: "37px",
                paddingRight: "15px",
              }}
            />
            <text className="subway">(+598) 92 291 919</text>
          </a>
          <a
            className="row_row"
            href="https://instagram.com/imarangatubeach"
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon
              style={{
                color: "#fff",
                fontSize: "37px",
                paddingRight: "15px",
              }}
            />
            <text className="subway">@imarangatubeach</text>
          </a>

          <div className="row_row">
            <PlaceOutlinedIcon
              style={{
                color: "#fff",
                fontSize: "39px",
                paddingRight: "15px",
              }}
            />
            <text className="subway">
              Rambla Claudio Williman Parada 7, Playa Mansa, Punta del Este
            </text>
          </div>
        </div>
        <p className="s">
          © 2025 I'marangatú • All rights reserved • Web by{" "}
          <a className="href" href="https://linktr.ee/recorals">
            Coral
          </a>
          {/* <button>
            <a>Coral</a>
          </button> */}
        </p>
      </div>
    );
  };

  const DesktopView = () => {
    return (
      <div className="footer">
        <div className="left">
          <img src={logo} className="footer_img" alt="logo" />
        </div>
        <div className="right">
          <p className="title">{i18n({ index: "contact", language })}</p>

          <a
            className="row_row"
            href="https://wa.me/59892291919"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Phone
              style={{
                color: "#fff",
                fontSize: "35px",
                paddingRight: "15px",
              }}
            />
            <text className="subway">(+598) 92 291 919</text>
          </a>
          <a
            className="row_row"
            href="https://instagram.com/imarangatubeach"
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon
              style={{
                color: "#fff",
                fontSize: "35px",
                paddingRight: "15px",
              }}
            />
            <text className="subway">@imarangatubeach</text>
          </a>

          <div className="row_row">
            <PlaceOutlinedIcon
              style={{
                color: "#fff",
                fontSize: "35px",
                paddingRight: "15px",
              }}
            />
            <text className="subway">
              Rambla Claudio Williman Parada 7, Playa Mansa, Punta del Este
            </text>
          </div>
        </div>
        <p className="designed_by">
          © 2025 I'marangatú • All rights reserved • Web by{" "}
          <a className="href" href="https://linktr.ee/recorals">
            Coral
          </a>
          {/* <button>
            <a>Coral</a>
          </button> */}
        </p>
      </div>
    );
  };

  return <div>{isMobile ? <MobileView /> : <DesktopView />}</div>;
};
